import { NgxPopperjsModule } from 'ngx-popperjs';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { AuthPageComponent } from './auth-page/auth-page.component';
import { FooterComponent } from './footer/footer.component';
import { IngridButtonModule } from './ingrid-button/ingrid-button.module';
import { ToastsModule } from './toasts/toasts.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    ToastsModule,
    IngridButtonModule,
    NgxPopperjsModule
  ],
  declarations: [FooterComponent, AuthPageComponent],
  exports: [FooterComponent, AuthPageComponent]
})
export class ComponentsModule {}
